import { Typography } from '@repo/ui';
import styles from './ActionPlan.module.scss';

interface PendingResultsBannerProps {
  latestKitDate: string;
  currentKitDate: string;
}

const PendingResultsBanner = ({
  latestKitDate,
  currentKitDate,
}: PendingResultsBannerProps) => {
  return (
    <div className={styles.pendingResultsBanner}>
      <Typography variant='body-s' className={styles.pendingResultsBannerText}>
        Your action plan from the {latestKitDate} kit is on the way! While we
        finish it up, here's your most recent action plan from your previous
        results ({currentKitDate}).
      </Typography>
    </div>
  );
};

export default PendingResultsBanner;
